module.exports = __webpack_public_path__ + "static/media/Spider Suit Boy.3c831793.jpg";